'use strict';

function CustomPrivacyDirective() {
    "ngInject";


    const getTemplate = () => {
        return '<div layout="row layout-margin">'+
      '<div ng-repeat="info in privacy.privacyInfo.info">'+
      '<div ng-bind-html="info.text">'+
        '{{info.text}}'+
      '</div>'+
    '</div>'+
  '</div>';
    };

    return {
        restrict: 'E',
        template: getTemplate(),
        controller: 'PrivacyCtrl as privacy'
    };
}

export default {
    name: 'customPrivacy',
    fn: CustomPrivacyDirective
};
